export const Util = {
 JSON_COPY:(obj)=>{
 return JSON.parse(JSON.stringify(obj));
 }

}
export function cleanUpTempValues(obj) {
    // Iterate over each key in the object
    for (let key in obj) {
      // Check if the key starts with "_$"
      if (key.startsWith("_$")) {
        // Delete the key if it matches the condition
        delete obj[key];
      } else if (typeof obj[key] === 'object' && obj[key] !== null) {
        // If the value is an object, apply the function recursively
        cleanUpTempValues(obj[key]);
      }
    }
    return obj;
  }
  